import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHandHeartFill = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M20.9989 6.85406C21.0321 5.3738 20.278 4.07987 19.1658 3.43188C18.2121 2.87618 17.0309 2.82501 16 3.46857C14.9691 2.82501 13.7879 2.87618 12.8342 3.43188C11.722 4.07987 10.9679 5.3738 11.0011 6.85406C11.0439 8.76288 12.5222 10.3177 14.6854 11.6027C15.087 11.8412 15.5162 12.1113 16 12.1113C16.4838 12.1113 16.913 11.8412 17.3146 11.6027C19.4778 10.3177 20.9561 8.76288 20.9989 6.85406Z"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M8.38905 12.3277L6.3994 13.5713C6.0387 13.218 5.54479 13.0002 5 13.0002H4C2.89543 13.0002 2 13.8956 2 15.0002V19.0002C2 20.1047 2.89543 21.0002 4 21.0002H5C5.74028 21.0002 6.38663 20.598 6.73244 20.0002H7.52786C7.68311 20.0002 7.83622 20.0363 7.97508 20.1057L10.3252 21.2808C11.3197 21.7781 12.4516 21.9296 13.5419 21.7116L16.7513 21.0697C17.1905 20.9818 17.6046 20.7967 17.9629 20.528L21.0334 18.2251C21.6419 17.7687 22 17.0525 22 16.2919V16.2362C22 14.4655 20.1366 13.3138 18.5528 14.1057C17.8632 14.4505 17.226 14.981 16.5846 15.4086C16.9556 14.2956 16.366 13.0609 15.1949 12.7681L11.4792 11.8392C10.4255 11.5758 9.31005 11.7521 8.38905 12.3277Z"
	})]
});
export default SvgHandHeartFill;
